/*
https://splidejs.com/guides/getting-started/
*/

import Splide from '@splidejs/splide';

document.addEventListener( 'DOMContentLoaded', function() {
    const slider = document.querySelector('.photo-gallery-section__bna__slider');

    if( slider ) {
        const counter = slider.querySelector('.slider-info .slider-numbers');

        var splide = new Splide( '.photo-gallery-section__bna__slider' , {
            type: 'loop',
            speed: 1000,
            arrows: true,
            pagination: false,
            rewind: false,
            perPage: 1,
            perMove: 1,
            gap: 10,
            waitForTransition: true,
            arrowPath: 'M37.057,0l-.651.651,11.38,11.381H.026L0,12.943H47.812L36.406,24.349l.651.651L49.114,12.943l.443-.443-.468-.468Z'
        });
        splide.mount();

        // Function to update the counter
        function updateCounter(splide) {
            if( counter ) {
                var currentSlide = splide.index + 1;  // +1 because index is 0-based
                var totalSlides = splide.length;
                counter.textContent = `${currentSlide}/${totalSlides}`;
            }
        }

        // Initial counter update
        updateCounter(splide);

        // Update counter on slide change
        splide.on('move', function () {
            updateCounter(splide);
        });
    }
});